import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstanceV2 from '../../Apis/AxiosV2';
import {LOG_SERVICE, VEHICLE_ACCESS_LOG} from '../EndPoints';

export const GetUserAccessList = createAsyncThunk(
    'accessHistory/getUserAccessList',
    async (body, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post('log-service/user-access/get-all-pageable', body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const getAllUserAccessLogByUserId = createAsyncThunk(
    'accessHistory/getAllUserAccessLogByUserId',
    async (params, { dispatch, getState }) => {
        const {userId, pagination}=params;
        const result = await apiInstanceV2
            .post(`log-service/user-access/get-all-pageable/user-id/${userId}`,pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetVehicleAccessList = createAsyncThunk(
    'accessHistory/getVehicleAccessList',
    async (body, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post('log-service/vehicle-access/get-all-pageable', body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const getAllVehicleAccessLogByVehicleId = createAsyncThunk(
    'accessHistory/getAllVehicleAccessLogByVehicleId',
    async (params, { dispatch, getState }) => {
        const {vehicleId, pagination}=params;
        const result = await apiInstanceV2
            .post(`${LOG_SERVICE.getAllVehicleAccessLogByVehicleId}${vehicleId}`,pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

